<script setup>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useModalStore } from "@/stores/modal.js";

// Stores
const modalStore = useModalStore();

// I18n
const { t } = useI18n();

onMounted(async () => { });
</script>

<template>
  <div class="justify-center items-center w-full">
  </div>
</template>

<style lang="scss" scoped>

</style>
